import React, { useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { DatePicker } from "antd";
import moment from "moment";
import { Input } from "antd";
import Preview from "./Preview";
import { useInvoiceProvider } from "../../../../Providers/Vendor/invoice";
import { InvoiceStatusLabel, roles } from "../../../../Utils/constants";
import ViewInvoice from "./ViewInvoice";
import StatusLabel from "../../../../Components/StatusLabel";
import CustomTable from "../../../../Components/Table";

const headCells = [
  {
    id: "Month",
    numeric: false,
    disablePadding: false,
    label: "Month",
  },
  {
    id: "TotalHours",
    numeric: false,
    disablePadding: false,
    label: "Total Hours",
  },
  {
    id: "Amount",
    numeric: false,
    disablePadding: false,
    label: "Amount",
  },
  {
    id: "Status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
];

export default function InvoiceHistory({ jobId, job, setJobInfo }) {
  const [createInvoice, setCreateInvoice] = useState(false);
  const [month, setMonth] = React.useState();
  const [preview, setPreview] = useState(false);
  const [invoice, setInvoice] = useState();
  const [hoursInMonth, setHoursInMonth] = useState(0);
  const [hourlyRate, setHourlyRate] = useState(null);
  const [inputHourlyRate, setInputHourlyRate] = useState();
  const [dueDate, setDueDate] = useState();
  const [comment, setComment] = useState("");
  const {
    weeksOfMonth,
    fetchInvoiceHoursForMonth,
    fetchInvoiceHistory,
    invoices,
  } = useInvoiceProvider();

  useEffect(() => {
    if (month) fetchInvoiceHoursForMonth({ jobId, start: month });
    fetchInvoiceHistory(roles.vendor, jobId);
  }, [month]);

  useEffect(() => {
    sumHoursForMonth();
  }, [weeksOfMonth]);

  function onChangeMonth(date, dateString) {
    const selctMonth = moment(dateString, "YYYY-MM-DD").format("MM-YYYY");
    if (selctMonth !== "Invalid date") setMonth(selctMonth);
  }
  function sumHoursForMonth() {
    const hoursArray = [];

    for (let i = 0; i < weeksOfMonth.length; i++) {
      const time = weeksOfMonth[i];
      const hours = parseInt(time.hours) + parseInt(time.minutes) / 60;
      hoursArray.push(hours);
    }
    const totalHours = hoursArray.reduce((acc, curr) => acc + curr, 0);
    setHoursInMonth(totalHours.toFixed(3));
  }

  const changeHourlyRate = () => {
    if (inputHourlyRate > 1) setHourlyRate(inputHourlyRate);
  };

  const CustomRow = ({ row }) => {
    return (
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={row.month}
        className="cursor-pointer"
        onClick={() =>
          setInvoice({
            jobId: row.job_id,
            start: row.month,
            invoiceId: row.id,
            invoiceStatus: row.status,
          })
        }
      >
        <TableCell align="left">
          {moment(row.month).format("MM/YYYY")}
        </TableCell>
        <TableCell align="left">{row.hours}</TableCell>
        <TableCell align="left">{row.amount}</TableCell>
        <TableCell align="left">
          <StatusLabel data={InvoiceStatusLabel[row.status]} />
        </TableCell>
      </TableRow>
    );
  };

  return (
    <>
      {!preview && !createInvoice && !invoice ? (
        <div style={{ marginTop: "30px" }}>
          <div className="flex flex-row justify-end">
            <button
              style={{
                width: "175px",
                height: "40px",
                background: "#139588",
                borderRadius: "5px",
                color: "white",
                marginBottom: "30px",
              }}
              onClick={() => {
                setCreateInvoice(true);
              }}
            >
              New Invoice
            </button>
          </div>
          <CustomTable
            title="Invoices"
            headCells={headCells}
            rows={invoices}
            CustomRow={CustomRow}
          />
        </div>
      ) : (
        !preview &&
        !invoice && (
          <div className="mt-8">
            <span
              className="cursor-pointer"
              onClick={() => {
                setCreateInvoice(!createInvoice);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
            </span>
            <div className="bg-white p-4 rounded-md mt-8 space-y-4">
              <div className="flex flex-row justify-between">
                <div className="flex flex-col">
                  <span className="mb-2">Month</span>
                  <DatePicker onChange={onChangeMonth} picker="month" />
                </div>
                <div className="flex flex-col">
                  <span>Hourly Rate</span>
                  <div className="flex flex-row items-center space-x-2">
                    <span className="mt-2">
                      <Input
                        defaultValue={hourlyRate}
                        className="h-8"
                        type="number"
                        onChange={(e) => setInputHourlyRate(e.target.value)}
                      />
                    </span>
                    {month && (
                      <span
                        className="text-blue-400 cursor-pointer"
                        onClick={changeHourlyRate}
                      >
                        Change
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col">
                  <span>Due Date</span>
                  <span className="mt-2">
                    <DatePicker
                      format="DD-MM-YYYY"
                      onChange={(date, dateString) => setDueDate(dateString)}
                      disabledDate={(current) => {
                        return (
                          moment().add(-1, "days") >= current
                          // ||
                          // moment().add(1, "month") <= current
                        );
                      }}
                    />
                  </span>
                </div>
              </div>
              <div>
                <span>Comments</span>
                <Input
                  className="h-8"
                  placeholder="Enter Comments"
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>
              <div className="relative overflow-x-auto">
                <table className="w-1/2 text-md text-left text-gray-700 border-collapse border">
                  <thead className="text-sm text-gray-900 bg-gray-100">
                    <tr className="border">
                      <th scope="col" className="px-6 py-3">
                        Week
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Hours
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {weeksOfMonth.map((week) => {
                      return (
                        <tr className="bg-white border">
                          <th
                            scope="row"
                            className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                          >
                            {moment.utc(week.start).format("DD-MMM") +
                              " " +
                              moment.utc(week.end).format("DD-MMM")}
                          </th>
                          <td className="px-6 py-4">
                            {`${week.hours} : ${week.minutes}`}{" "}
                          </td>
                          <td className="px-6 py-4">{`${week.status.toLowerCase()}`}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr className="font-semibold text-gray-900">
                      <th scope="row" className="px-6 py-3 text-base">
                        Total Hours
                      </th>
                      <td className="px-6 py-3">{Math.floor(hoursInMonth)}</td>
                    </tr>
                  </tfoot>
                </table>
                {hourlyRate && (
                  <tr className="font-semibold text-gray-900">
                    <th scope="row" className="px-6 py-3 text-base">
                      Total Amount: {hoursInMonth * hourlyRate}
                    </th>
                  </tr>
                )}
              </div>

              <div className="flex justify-end py-2">
                <div className="space-x-4">
                  <button
                    style={{
                      width: "144px",
                      height: "34px",
                      border: "1px solid #2EBAA3",
                      borderRadius: "4px",
                      color: "#2EBAA3",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      if (month) {
                        changeHourlyRate();
                        setPreview(true);
                      }
                    }}
                    style={{
                      width: "144px",
                      height: "34px",
                      background: "#2EBAA3",
                      borderRadius: "4px",
                      color: "white",
                    }}
                  >
                    Preview
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      )}
      {preview && (
        <Preview
          setPreview={setPreview}
          month={month}
          hoursInMonth={hoursInMonth}
          hourlyRate={hourlyRate}
          dueDate={dueDate}
          comment={comment}
          jobDetails={job}
          setJobInfo={setJobInfo}
        />
      )}
      {invoice && (
        <ViewInvoice
          invoice={invoice}
          setInvoice={setInvoice}
          showJobInfo={false}
        />
      )}
    </>
  );
}
